import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  margin-top: -180px;
  margin-left: -86px;
  width: 306px;
  height: 150px;
  display: block;
  &.single {
    width: 156px;
    margin-left: -10px;
  }
  background-color: #fff;
  display: none;
`;
const ImgWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.4);
  border: 3px solid #fff;
  box-sizing: border-box;
`;

const BookPreviewToolTip = ({ pages, data }) => {
  if (!pages) return null;
  const renderImage = () => {
    if (data === 1) {
      return <img src={pages[0]} alt="" />;
    } else {
      return (
        <>
          <img src={pages[data - 2]} alt="" />
          <img src={pages[data - 1]} alt="" />
        </>
      );
    }
  };

  return (
    <Wrap className={data === 1 ? "preview-tooltip single" : "preview-tooltip"}>
      <ImgWrap>{renderImage(data)}</ImgWrap>
    </Wrap>
  );
};

export default React.memo(BookPreviewToolTip);
